export enum Endpoints {
  bookingDashboard = "/bookingDashboard",
  bookingDashboardDetails = "/bookingDashboard/details/:id",
  bookingInvoice = "/bookingDashboard/invoice",
  newBookingDashboard = "/newBookingDashboard",
  newBookingDashboardDetails = "/newBookingDashboard/details/:id",
  bcomBookingDashboard = "/bcomBooking",
  bcomBookingDashboardDetails = "/bcomBooking/details/:id",
  extensionOfferManage = "/extensionOfferManage",
  hcfChargeDashboard = "/hcfChargeDashboard",
  powerSearch = "/powerSearch",
  callerVerification = "/callerVerification",
  companyDashboard = "/companyDashboard",
  dealsDashboard = "/dealsDashboard",
  events = "/events",
  faq = "/faq",
  hostPayoutDashboard = "/hostPayoutDashboard",
  index = "/",
  managePromoCodes = "/promocodes/manage",
  manageTokens = "/manageTokens",
  manageUsers = "/manageUsers",
  manageRole = "/manageRole",
  onboarding = "/onboarding",
  pmsFeesManage = "/pmsFeesManage",
  propertyDashboard = "/propertyDashboard",
  redeemPromoCodes = "/promocodes/redeem",
  reports = "/reports",
  sendEmails = "/sendEmails",
  reviewManagement = "/reviewManagement",
  feeMapping = "/feeMapping",
  heroBanner = "/homeConfig/heroBanner",
  propertyManagement = "/homeConfig/propertyManagement",
  newToWhimstay = "/homeConfig/newToWhimstay",
  userDashboard = "/userDashboard",
  emailCommunication = "/emailCommunication",
  emailCommunicationDetails = "/emailCommunication/details/:id",
  systemEmailLogDetails = "/systemEmailLog/details/:id",
  systemEmailLog = "/systemEmailLog",
  forwardEmail = "/emailCommunication/details/:id/forward",
  managePropertyDiscount = "/discount/property",
  manageCompanyDiscount = "/discount/company",
  regionalLanding = "/regional-location",
  globalRulesManagement = "/proxy-rules/global-rules-management",
  hostRulesManagement = "/proxy-rules/host-rules-management",
  travelAgentDashboard = "/travelAgentDashboard",
  agentManagement = "/agentManagement",
  commissionDashboard = "/commissionDashboard",
  agentPayoutDashboard = "/agentPayoutDashboard",
  hostContactInfo = "/contact-info",
  checkIns = "/check-ins",
}
